export default "__VITE_ASSET__JrLkSD2N__"